import React from 'react'
import Products from './Products';

const Home = () => {
    return (
        <>
            <div className="container px-0" style={{ marginTop: "1", marginBottom: 50}}>
                <div id="FakeShopCarouselInterval" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active"  data-bs-interval="10000">
                        <img
          src="/banners/kamagrabaner.png"
          className="d-block w-100"
          alt="Banner"
          style={{ height: "100%", objectFit: "cover" }}
        />
                        </div>
                        {/* <div className="carousel-item" data-bs-interval="2000">
                            <img src="banners/2.png" className="d-block w-100" alt="..." />
                        </div>
                        <div className="carousel-item" data-bs-interval="2000">
                            <img src="banners/3.png" className="d-block w-100" alt="..." />
                        </div>
                        <div className="carousel-item" data-bs-interval="2000">
                            <img src="banners/4.png" className="d-block w-100" alt="..." />
                        </div> */}
                    </div>
                    {/* <button className="carousel-control-prev" type="button" data-bs-target="#FakeShopCarouselInterval" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Prethodni</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#FakeShopCarouselInterval" data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Sledeci</span>
                    </button> */}
                </div>
                <Products />
            </div>
        </>
    )
}

export default Home;